var _rect, _rect2, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect3, _circle2, _circle3, _circle4, _rect4, _path34, _circle5, _rect5, _rect6, _rect7, _path35, _path36, _path37, _g, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 202,
    viewBox: "0 0 205 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 200,
    height: 200,
    fill: "#D8D8D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 5,
    y: 2,
    width: 200,
    height: 200,
    fill: "#D8D8D8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4985,
    cy: 97.2676,
    r: 4,
    fill: "#EB254C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98015 139.068L5.97915 139.065C4.74315 135.456 6.69415 131.607 10.3362 130.471L52.3982 117.349C56.0382 116.214 59.9892 118.217 61.2252 121.825L61.2262 121.828C62.4622 125.437 61.8032 131.882 58.1612 133.018L14.8072 143.543C11.1672 144.678 7.21515 142.675 5.98015 139.068Z",
    fill: "#FFD1C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0212 141.064L41.9292 136.96L39.0962 121.138L23.6572 127.028L25.0212 141.064Z",
    fill: "#FCB4A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3519 122.272C33.3519 122.272 43.5839 117.818 64.6979 115.248L101.634 110.41C101.634 110.41 131.664 112.276 133.5 118.5C135.337 124.724 129 193.323 129 193.323H67.7059L52.6419 153.403L32.0079 154.525L30.4639 125.433L33.3519 122.272Z",
    fill: "#D3D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2424 84.0086C79.1344 86.1436 78.2704 88.5376 76.3134 89.3556C74.3554 90.1726 72.0454 89.1046 71.1534 86.9696C70.2624 84.8346 71.1254 82.4406 73.0834 81.6226C75.0404 80.8046 77.3504 81.8736 78.2424 84.0086Z",
    fill: "#343434"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8697 88.1364C80.3577 94.0934 77.5457 100.94 71.5887 103.428C65.6317 105.917 58.7857 103.105 56.2967 97.1474C55.0527 94.1694 52.8147 91.4794 53.9517 88.7124C55.0887 85.9454 59.5987 83.0994 62.5777 81.8554C68.5347 79.3674 75.3807 82.1784 77.8697 88.1364Z",
    fill: "#343434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3428 114.521L70.4668 119.047L63.9448 103.436L79.0728 97.1162L86.3428 114.521Z",
    fill: "#FFD1C2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3439 111.573L84.2779 109.575L80.0269 99.4004L64.8989 105.719L67.3439 111.573Z",
    fill: "#FCB4A5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.724 97.9164C53.618 98.7964 52.623 101.215 53.502 103.32C54.381 105.426 56.802 106.418 58.908 105.539C61.015 104.659 62.009 102.239 61.13 100.134C60.251 98.0294 57.83 97.0364 55.724 97.9164Z",
    fill: "#FFDED3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6546 88.3373C76.5486 89.2173 75.5536 91.6373 76.4326 93.7423C77.3126 95.8473 79.7326 96.8403 81.8386 95.9603C83.9456 95.0803 84.9406 92.6603 84.0606 90.5553C83.1816 88.4503 80.7606 87.4573 78.6546 88.3373Z",
    fill: "#FFDED3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1746 90.6383C82.5686 96.3683 79.6706 103.034 73.7016 105.527C67.7336 108.02 60.9556 105.396 58.5616 99.6663C56.1686 93.9363 59.0666 87.2703 65.0336 84.7773C71.0026 82.2843 77.7806 84.9083 80.1746 90.6383Z",
    fill: "#FFDED3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6287 96.3282L73.8467 97.4902L72.2437 89.7432L76.6287 96.3282Z",
    fill: "#FFAD9E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.29 93.1897C80.193 93.2307 80.078 93.2097 80.001 93.1287C79.903 93.0247 79.907 92.8597 80.011 92.7617L82.374 90.5247C82.48 90.4247 82.644 90.4307 82.742 90.5347C82.84 90.6387 82.836 90.8027 82.732 90.9017L80.369 93.1387C80.345 93.1607 80.318 93.1777 80.29 93.1897Z",
    fill: "#FCB4A5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8996 98.0062C70.2936 98.9502 69.5036 100.178 68.1346 100.75C66.7656 101.322 65.3366 101.021 64.9416 100.077C64.5476 99.1332 65.3376 97.9042 66.7076 97.3332C68.0756 96.7602 69.5056 97.0622 69.8996 98.0062Z",
    fill: "#FF9094"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4845 91.9947C78.1155 92.5667 77.3255 93.7957 77.7195 94.7397C78.1135 95.6827 79.5435 95.9847 80.9125 95.4127C80.9415 95.4007 80.9685 95.3867 80.9975 95.3727C81.0585 94.1597 80.9225 92.9277 80.5625 91.7217C80.2125 91.7547 79.8465 91.8437 79.4845 91.9947Z",
    fill: "#FF9094"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4863 101.881C59.4533 101.895 59.4183 101.902 59.3803 101.901L55.3243 101.806C55.1813 101.803 55.0683 101.684 55.0713 101.541C55.0753 101.397 55.1933 101.284 55.3373 101.287L59.3923 101.381C59.5353 101.385 59.6493 101.504 59.6463 101.647C59.6433 101.753 59.5783 101.842 59.4863 101.881Z",
    fill: "#FCB4A5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.4348 78.9907C70.6098 81.8037 69.2818 85.0347 66.4698 86.2097C63.6578 87.3847 60.4248 86.0567 59.2508 83.2447C58.0758 80.4327 59.4028 77.2007 62.2158 76.0257C65.0278 74.8507 68.2598 76.1777 69.4348 78.9907Z",
    fill: "#343434"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8749 83.4065C65.2639 86.7305 63.6949 90.5505 60.3709 91.9385C57.0469 93.3275 53.2269 91.7585 51.8379 88.4345C50.4499 85.1105 52.0189 81.2905 55.3429 79.9025C58.6669 78.5135 62.4869 80.0825 63.8749 83.4065Z",
    fill: "#343434"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8567 83.6987C51.8567 83.6987 49.2717 76.6567 56.8367 77.2947C64.4007 77.9337 62.7787 70.7857 67.7527 72.1837C72.7257 73.5807 72.0247 66.1447 77.4367 67.2237C82.8487 68.3027 80.8927 79.1747 75.4687 83.3717L55.1607 84.4297L51.8567 83.6987Z",
    fill: "#343434"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9399 96.8797L60.0559 101.627C60.3139 102.02 60.8149 102.173 61.2499 101.992C61.6939 101.806 61.9369 101.324 61.8209 100.856L60.0029 93.4967C60.0029 93.4967 59.6349 89.7297 63.6729 88.8637C67.7109 87.9987 67.3039 82.4257 73.5309 83.9567L77.1129 81.3057L62.5769 81.8567C62.5769 81.8567 57.0019 90.5947 57.1069 91.0427C57.2119 91.4897 56.9399 96.8797 56.9399 96.8797Z",
    fill: "#343434"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.12 169.773C195.12 171.305 193.878 172.547 192.347 172.547C190.814 172.547 189.572 171.305 189.572 169.773C189.572 168.241 190.814 167 192.347 167C193.878 167 195.12 168.241 195.12 169.773Z",
    fill: "#16DDD7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.547 35.773C70.547 37.305 69.305 38.547 67.774 38.547C66.241 38.547 65 37.305 65 35.773C65 34.241 66.241 33 67.774 33C69.305 33 70.547 34.241 70.547 35.773Z",
    fill: "#16DDD7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0977 141.027C4.6637 138.776 4.5317 135.039 6.8057 132.729L32.4797 106.823L34.3537 104.809C34.4117 104.746 34.4657 104.68 34.5137 104.609L36.6937 101.402L39.8517 97.0603C40.0227 96.8113 40.2177 96.5423 40.4437 96.2463L40.5817 96.0563C40.5817 96.0563 40.5897 96.0503 40.6057 96.0383C44.0807 91.5423 46.2407 90.0263 47.2947 89.5143C47.6997 89.3183 48.1657 89.2823 48.6017 89.4183L51.0047 90.1653L55.5367 91.4743C56.5347 91.7503 57.1337 92.7653 56.8747 93.7413C56.6167 94.7173 55.5727 95.3703 54.5747 95.0943L50.5057 93.9723L55.4157 95.3203C55.4867 95.3393 55.5557 95.3633 55.6227 95.3903C56.8217 95.8723 57.0187 97.4883 56.0387 98.2853C55.5887 98.6523 54.9957 98.9973 54.4787 98.8543L52.2097 98.3123C51.3967 98.1173 50.5697 98.5083 50.2287 99.2473L47.5867 104.969C47.5497 105.05 47.5187 105.134 47.4957 105.221C47.2827 105.999 45.9987 110.18 42.5757 112.305C42.4527 112.381 42.3397 112.47 42.2407 112.575C40.7397 114.161 28.2407 127.381 24.0697 131.988",
    fill: "#FFD1C2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97363 141.161C5.74063 140.02 5.04063 138.485 5.00163 136.837C4.96463 135.24 5.55863 133.736 6.67463 132.601L32.3496 106.695L34.2206 104.685C34.2726 104.629 34.3196 104.57 34.3626 104.507L36.5426 101.3L39.7046 96.9529C39.8786 96.6979 40.0796 96.4219 40.2986 96.1359L40.4696 95.9129C44.0126 91.3329 46.2176 89.8349 47.2156 89.3499C47.6646 89.1329 48.1766 89.0949 48.6566 89.2439L51.0586 89.9919L55.5866 91.2989C56.6776 91.6019 57.3346 92.7179 57.0506 93.7879C56.9106 94.3179 56.5496 94.7839 56.0596 95.0639C55.9456 95.1299 55.8266 95.1839 55.7056 95.2269C56.3096 95.4809 56.7256 96.0119 56.8246 96.6659C56.9266 97.3439 56.6766 98.0019 56.1546 98.4269C55.4966 98.9619 54.9166 99.1649 54.4306 99.0299L52.1666 98.4889C51.4426 98.3159 50.6976 98.6669 50.3936 99.3239L47.7526 105.046C47.7186 105.118 47.6926 105.193 47.6716 105.269C47.4456 106.092 46.1426 110.306 42.6716 112.461C42.5546 112.534 42.4566 112.612 42.3726 112.7C40.9516 114.203 28.3636 127.517 24.2046 132.11L23.9336 131.866C28.0956 127.27 40.6856 113.953 42.1086 112.45C42.2116 112.34 42.3366 112.239 42.4796 112.151C45.8356 110.067 47.0996 105.973 47.3196 105.173C47.3466 105.074 47.3816 104.979 47.4216 104.892L50.0626 99.1709C50.4386 98.3569 51.3596 97.9209 52.2516 98.1339L54.5216 98.6769C54.9836 98.8049 55.5386 98.4569 55.9246 98.1439C56.3456 97.8008 56.5466 97.2689 56.4636 96.7209C56.3836 96.1899 56.0446 95.7599 55.5556 95.5589C55.4946 95.5349 55.4316 95.5139 55.3676 95.4959L54.6576 95.3009C54.6136 95.2919 54.5696 95.2819 54.5256 95.2689L50.4576 94.1479L50.5546 93.7969L50.5576 93.7979L54.7416 94.9459C55.1236 95.0209 55.5226 94.9519 55.8786 94.7479C56.2846 94.5149 56.5826 94.1319 56.6986 93.6949C56.9316 92.8159 56.3886 91.8999 55.4876 91.6499L50.9536 90.3409L48.5476 89.5929C48.1566 89.4709 47.7406 89.5019 47.3746 89.6789C46.4056 90.1489 44.2546 91.6149 40.7496 96.1489L40.5906 96.3539C40.3726 96.6389 40.1766 96.9099 40.0026 97.1629L36.8406 101.51L34.6636 104.712C34.6106 104.79 34.5526 104.864 34.4876 104.933L32.6136 106.948L6.93463 132.857C5.88863 133.921 5.33063 135.331 5.36663 136.828C5.40263 138.377 6.06163 139.82 7.22163 140.893L6.97363 141.161Z",
    fill: "#F89686"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6191 109.291C37.5991 109.282 37.5871 109.276 37.5811 109.273L37.7391 108.944C37.7611 108.957 40.2471 110.119 42.1011 109.194C43.0711 108.71 43.7111 107.733 44.0041 106.29L45.0951 100.911L45.2781 99.833C45.3671 99.309 45.7081 98.859 46.1901 98.63C47.6101 97.956 48.4001 97.583 48.5381 97.52L48.8621 97.375L52.9091 98.291L52.8281 98.647L48.9001 97.758L48.6881 97.853C48.5541 97.914 47.7441 98.296 46.3471 98.96C45.9721 99.138 45.7071 99.487 45.6381 99.894L45.4531 100.978L44.3621 106.363C44.0451 107.922 43.3391 108.985 42.2631 109.521C40.3551 110.472 37.9601 109.447 37.6191 109.291Z",
    fill: "#F89686"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3659 96.4157L43.1299 96.1377L45.9069 93.7797C45.9439 93.7457 47.0029 92.8227 51.0059 93.9217L50.9089 94.2727C47.1559 93.2437 46.1559 94.0467 46.1459 94.0557L43.3659 96.4157Z",
    fill: "#F89686"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6422 153.403L48.0322 141.027L31.3882 142.84L32.0082 154.525L52.6422 153.403Z",
    fill: "#8F8F8F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9355 117.204L81.0985 125.418L85.8125 112.677L69.9355 117.204Z",
    fill: "#FFD1C2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8378 114.644L64.6978 115.248L73.9048 137.895L81.0978 125.418L68.8378 114.644Z",
    fill: "#1D1D1D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0981 125.418L92.3401 132.195L89.8471 111.954L85.7351 112.493L81.0981 125.418Z",
    fill: "#1D1D1D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.678 80.3393C153.678 81.0788 153.079 81.6785 152.339 81.6785C151.599 81.6785 151 81.0788 151 80.3393C151 79.5998 151.599 79 152.339 79C153.079 79 153.678 79.5998 153.678 80.3393Z",
    fill: "#8F8F8F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.323 80.3393C159.323 81.0788 158.723 81.6785 157.984 81.6785C157.244 81.6785 156.645 81.0788 156.645 80.3393C156.645 79.5998 157.244 79 157.984 79C158.723 79 159.323 79.5998 159.323 80.3393Z",
    fill: "#8F8F8F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.967 80.3393C164.967 81.0788 164.368 81.6785 163.628 81.6785C162.889 81.6785 162.289 81.0788 162.289 80.3393C162.289 79.5998 162.889 79 163.628 79C164.368 79 164.967 79.5998 164.967 80.3393Z",
    fill: "#8F8F8F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M158.435 193H40.5908",
    stroke: "#8F8F8F",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 86,
    width: 89,
    height: 84,
    rx: 2,
    fill: "#EB254C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106,
    cy: 94,
    r: 2,
    fill: "#E9E9E9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 94,
    r: 2,
    fill: "#E9E9E9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 94,
    r: 2,
    fill: "#E9E9E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 100,
    width: 85,
    height: 67,
    fill: "#FFBECC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101 104C101 101.791 102.791 100 105 100H181.205L101 161.5V104Z",
    fill: "#F4F4F4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 143,
    cy: 145,
    r: 10,
    stroke: "#EB254C",
    strokeWidth: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 111,
    width: 4,
    height: 25,
    rx: 2,
    fill: "#EB254C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 120,
    width: 4,
    height: 11,
    rx: 2,
    transform: "rotate(-90 143 120)",
    fill: "#EB254C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 128,
    width: 4,
    height: 8,
    rx: 2,
    transform: "rotate(-90 143 128)",
    fill: "#EB254C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5117 65.9017C43.0917 65.3737 37.5057 58.9297 38.0347 51.5107C38.5647 44.0907 45.0067 38.5057 52.4267 39.0347C59.8457 39.5637 65.4317 46.0067 64.9027 53.4257C64.3737 60.8447 57.9307 66.4307 50.5117 65.9017Z",
    fill: "#1D1D1D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8505 58.0025L45.9355 49.0865L48.0865 46.9355L57.0025 55.8505L54.8505 58.0025Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0865 58.0025L57.0025 49.0865L54.8505 46.9355L45.9355 55.8505L48.0865 58.0025Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.436 63.0184H164.018C163.456 63.0184 163 62.363 163 61.5548V28.4636C163 27.6554 163.456 27 164.018 27H197.436C197.999 27 198.455 27.6554 198.455 28.4636V61.5548C198.455 62.363 197.999 63.0184 197.436 63.0184",
    stroke: "#8F8F8F",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.443 39.8683C175.44 39.4721 175.344 39.1496 175.221 38.832C174.996 38.252 175.238 37.5921 175.779 37.2932C176.079 37.1276 176.378 36.9616 176.678 36.7959C177.135 36.5433 177.592 36.2922 178.048 36.0385C178.584 35.7403 179.219 35.8276 179.657 36.2633C180.003 36.6075 180.384 36.9034 180.816 37.1363C181.296 37.3961 181.768 37.4011 182.251 37.1439C182.68 36.9152 183.058 36.6227 183.407 36.2869C183.77 35.9378 184.204 35.825 184.693 35.9359C184.799 35.9598 184.903 36.0058 184.998 36.0586C185.731 36.4677 186.463 36.8806 187.194 37.2936C187.762 37.6134 187.988 38.2501 187.75 38.8598C187.618 39.1971 187.528 39.5401 187.54 39.9071C187.58 41.0938 188.587 42.1126 189.773 42.1597C189.785 42.1601 189.798 42.1605 189.81 42.1608C190.426 42.1802 190.762 42.4271 190.889 43.03C191.083 43.9512 191.191 44.8834 191.075 45.8266C191.025 46.2349 190.97 46.6433 190.894 47.0479C190.864 47.2078 190.79 47.3666 190.706 47.5079C190.536 47.7939 190.282 47.9413 189.938 47.9455C188.854 47.9584 187.974 48.6012 187.652 49.5991C187.469 50.1666 187.533 50.7144 187.753 51.2587C187.967 51.789 187.798 52.3847 187.341 52.7258C187.208 52.8249 187.055 52.8979 186.909 52.9792C186.264 53.3389 185.619 53.6971 184.974 54.0561C184.444 54.3512 183.817 54.2688 183.388 53.8346C183.034 53.4756 182.656 53.1478 182.212 52.9043C182.194 52.8944 182.176 52.8849 182.158 52.8751C181.681 52.6031 181.206 52.6111 180.726 52.8728C180.299 53.1053 179.906 53.3841 179.582 53.7435C179.178 54.1898 178.448 54.355 177.854 53.9945C177.171 53.5805 176.466 53.2025 175.77 52.8094C175.233 52.5058 175.001 51.873 175.217 51.2914C175.328 50.9962 175.432 50.6992 175.44 50.3812C175.472 49.0824 174.49 48.0279 173.178 47.9478C172.507 47.9064 172.193 47.6424 172.068 46.9776C171.94 46.2995 171.849 45.6154 171.865 44.9229C171.88 44.2976 171.954 43.6773 172.087 43.0664C172.124 42.8951 172.201 42.7249 172.293 42.5745C172.462 42.2983 172.72 42.1627 173.051 42.1593C174.25 42.1479 175.181 41.3688 175.404 40.1935C175.428 40.0696 175.434 39.9428 175.443 39.8683Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.363 45.0475C186.363 47.7373 184.183 49.9181 181.493 49.9181C178.803 49.9181 176.622 47.7373 176.622 45.0475C176.622 42.3576 178.803 40.1768 181.493 40.1768C184.183 40.1768 186.363 42.3576 186.363 45.0475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.221 45.0472C184.221 46.5537 183 47.775 181.493 47.775C179.987 47.775 178.765 46.5537 178.765 45.0472C178.765 43.5406 179.987 42.3193 181.493 42.3193C183 42.3193 184.221 43.5406 184.221 45.0472Z",
    fill: "#E3E3E3"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.747 54C87.7823 54 87 54.814 87 55.8181V75.3994C87 76.4036 87.7823 77.2175 88.747 77.2175H123.248C123.772 77.2175 124.269 77.4624 124.601 77.8848L128.5 82.8483C128.85 83.293 129.503 83.293 129.853 82.8483L133.752 77.8848C134.084 77.4624 134.58 77.2175 135.105 77.2175H140.837C141.802 77.2175 142.584 76.4036 142.584 75.3994V55.8181C142.584 54.814 141.802 54 140.837 54H88.747Z",
    fill: "#E3E3E3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9266 63.0322C93.1842 63.0322 92.5825 62.41 92.5825 61.6424C92.5825 60.875 93.1842 60.2529 93.9266 60.2529H125.78C126.523 60.2529 127.124 60.875 127.124 61.6424C127.124 62.41 126.523 63.0322 125.78 63.0322H93.9266Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9178 69.9804C93.1802 69.9804 92.5825 69.3583 92.5825 68.5907C92.5825 67.8233 93.1802 67.2012 93.9178 67.2012H120.23C120.968 67.2012 121.566 67.8233 121.566 68.5907C121.566 69.3583 120.968 69.9804 120.23 69.9804H93.9178Z",
    fill: "white"
  })));
}
export default __webpack_public_path__ + "main/static/media/icon.ecf51d33.svg";
export { SvgIcon as ReactComponent };